import { call, put, takeLatest, all, cancelled, fork } from "redux-saga/effects"
import { generateTree } from "utils/utils"
import { map, filter, get } from "lodash"
import axios from "axios"
import { message } from "antd"
import { AMBASSADOR_USERS } from "utils/constants"
import {
  GET_STATUS_WATCHER,
  GET_DIMENSIONS_WATCHER,
  GET_DIVISIONS_WATCHER,
  GET_TEAMS_WATCHER,
  GET_RANKS_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MULTIPLE_WATCHER,
  GET_QUALITATIVE_WATCHER,
  GET_MULTIPLE_CHOICE_QUESTION_WATCHER,
  GET_QUALITATIVE_QUESTIONS_WATCHER,
  REFETCH_SENTIMENT_WORDCLOUD_WATCHER,
  DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER,
} from "./constants"

import {
  getStatusSuccess,
  getStatusFailed,
  getDimensionsSuccess,
  getDimensionsFailed,
  getDivisionsSuccess,
  getDivisionsFailed,
  getQualitativeSuccess,
  getQualitativeFailed,
  getTeamsSuccess,
  getTeamsFailed,
  getRanksSuccess,
  getRanksFailed,
  getMeasureColorRangeSuccess,
  getMultipleSuccess,
  getMultipleFailed,
  getMeasureInfoSuccess,
  getQualitativeQuestionsFailed,
  getQualitativeQuestionsSuccess,
} from "./actions"
import {
  isAmbassador,
  isModuleBySlug,
  KEY_CHECKBOX_EXCLUDE,
  KEY_ISOLATED_METRICS,
  LOCAL_COMPANY_ID,
  LOCAL_TOKEN,
  setItem,
} from "../../../utils/storage"
import {
  getQualitativeAnswersSuccess,
  getQualitativeAnswersWordCloudSuccess,
  getQualitativeAnswersSentimentWordcloudSuccess,
} from "../../Reports/QualitativeQuestionList/actions"
import { validate } from "../../../utils/functions"

// API's URL
const QualitativeAPI = (params) => {
  const segmentParam = params.id_segment
    ? `&id_segment=${params.id_segment}`
    : ""
  return `surveys/${params.id_survey}/questions/qualitative?f${segmentParam}`
}

const DimensionsAPI = (params) => {
  let url = `reports/measure/${params.measure}/dimensions`
  if (params.division) {
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.measure}/leaders/${params.division}/dimensions?f`
    } else {
      url = `reports/measure/${params.measure}/divisions/${params.division}/dimensions?f`
    }
  }
  return url
}

const RanksAPI = (params) => `reports/measure/${params.measure}/segment/rank`

const DivisionsAPI = (params) => {
  let segmentWithParams = !validate.empty(params.params.id_segment)
    ? `&id_segment=${params.params.id_segment}`
    : ""

  let paramsSegment = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""

  const excludeparam = params.isExclude ? "&exclude=true" : "&exclude=false"

  let url = `reports/measure/${params.measure}/divisions?f${excludeparam}${paramsSegment}${segmentWithParams}`
  if (params.isEngagement) {
    if (params.dimensionType == "Engagement") {
      url = `reports/measure/${params.measure}/divisions/engagement?f${excludeparam}${paramsSegment}`
      if (params.dimension) {
        url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}${paramsSegment}`
      }
    } else if (params.dimension) {
      url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}${paramsSegment}`
    }
  } else if (params.dimension) {
    url = `reports/measure/${params.measure}/dimensions/${params.dimension}/divisions?f${excludeparam}${paramsSegment}`
  }
  return url
}

const DivisionsAvailableAPI = (params) => {
  let segmentWithParams = !validate.empty(params.params.id_segment)
    ? `&id_segment=${params.params.id_segment}`
    : ""

  let paramsSegment = !validate.empty(params.id_segment)
    ? `&id_segment=${params.id_segment}`
    : ""

  const excludeparam = params.isExclude ? "&exclude=true" : "&exclude=false"
  return `reports/measure/${params.measure}/divisions?f${excludeparam}${paramsSegment}${segmentWithParams}`
}

const QuestionsAPI = (params) => {
  let paramsSegment = !validate.empty(params.params.id_segment)
    ? `&id_segment=${params.params.id_segment}`
    : ""
  let url = `reports/measure/${params.measure}/questions?f${paramsSegment}`
  if (params.division) {
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.measure}/leaders/${params.division}/questions?f${paramsSegment}`
    } else {
      url = `reports/measure/${params.measure}/divisions/${params.division}/questions?f${paramsSegment}`
    }
  }
  return url
}

const MultipleAPI = (params) => {
  let paramsSegment = !validate.empty(params.params.id_segment)
    ? `&id_segment=${params.params.id_segment}`
    : ""

  let url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?f${paramsSegment}`
  if (params.params.division) {
    if (params.id_survey_type === 2) {
      url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?id_position=${params.params.division}${paramsSegment}`
    } else {
      url = `reports/measure/${params.id_measure}/multiple-choice/question-answers?id_division=${params.params.division}${paramsSegment}`
    }
  }
  return url
}

const TeamsAPI = (params) => {
  let paramsSegment = !validate.empty(params.params.id_segment)
    ? `&id_segment=${params.params.id_segment}`
    : ""

  let url = `reports/measure/${params.measure}/leaders?f${paramsSegment}`
  if (params.dimension) {
    url = `reports/measure/${params.measure}/dimensions/${params.dimension}/leaders?f${paramsSegment}`
  }
  return url
}

function getQualitativeApi(params) {
  // Guard: sin id_survey resuelto (el backend solo lo resuelve cuando la
  // request trae id_segment — ver getQualitativeSaga) no hay survey contra el
  // cual pedir, y pegarle igual produce `surveys/null/questions/qualitative`.
  if (validate.empty(params.id_survey) || params.id_survey === 0) {
    return null
  }
  const url = QualitativeAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

function getDimensionsApi(params) {
  const url = DimensionsAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

function getRanksApi(params) {
  const url = RanksAPI(params)

  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

function getDivisionsApi(params) {
  // eslint-disable-line
  const url = DivisionsAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

function getDivisionsAvailableApi(params) {
  // eslint-disable-line
  const url = DivisionsAvailableAPI(params)
  let divisionToUse = params.params.id_divisionParent
    ? params.params.id_divisionParent
    : params.divisionToUseAmbassador
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: {
      id_division: divisionToUse,
    },
  })
}

function getQuestionsApi(params) {
  const url = QuestionsAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    params: params.params,
  })
}

function getMultipleApi(params) {
  const url = MultipleAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
    // params: params.params,
  })
}

function getStatusApi({ measure, params = {} }) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${measure}/status`,
    params,
  })
}

function getTeamsApi(params) {
  const url = TeamsAPI(params)
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

function getReportMeasureInfoApi(params) {
  let paramsSegment = validate.exist(params.id_segment)
    ? `id_segment=${params.id_segment}`
    : ""
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.measure}/info?${paramsSegment}`,
  })
}

function getWordCloudApi(params) {
  let url = `reports/measure/${params.measure}/answers/wordcloud`
  const isLeadershipMedition = params.id_survey_type === 2
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function getSentimentWordcloudApi(params) {
  let url = `reports/measure/${params.measure}/answers/sentiment-wordcloud`
  const isLeadershipMedition = params.id_survey_type === 2
  const extraParams = { ...params.params }
  if (isLeadershipMedition) {
    delete extraParams.id_division
  }
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      ...extraParams,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function getQualitativeAnswersApi(params) {
  let url = `reports/measure/${params.measure}/answers`
  const isLeadershipMedition = params.id_survey_type === 2
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL + url}`,
  })
}

// containers/Reports/SentimentAnalysis pega a sentiment-analysis/answers (no
// al endpoint plano de arriba, que es de la vista vieja QualitativeQuestion) —
// mismo endpoint que AnswersList usa para el listado paginado, así el bootstrap
// no reporta respuestas de un universo distinto al que ve el usuario.
function getSentimentAnalysisAnswersApi(params) {
  let url = `reports/measure/${params.measure}/sentiment-analysis/answers`
  const isLeadershipMedition = params.id_survey_type === 2
  const extraParams = { ...params.params }
  if (isLeadershipMedition) {
    delete extraParams.id_division
  }
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      ...extraParams,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function hasComparativeHistoryCompany() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/reports/comparative/active`,
  })
}

function getEvolutionHistoryMeasure({
  measure,
  params,
  position,
  isLeadership,
  divisionToUseAmbassador,
}) {
  let endpoint = `reports/measure/${measure}/historical/evolution/chart`
  if (
    divisionToUseAmbassador &&
    !isLeadership &&
    validRole({ role: [5] }) &&
    !params.id_division
  ) {
    params.id_division = divisionToUseAmbassador
  }

  if (params && !isLeadership && params.id_division) {
    endpoint = `${endpoint}/divisions/${params.id_division}`
  }

  if (params && isLeadership && position !== 0) {
    delete params.id_division
    endpoint = `${endpoint}/team/${position}`
  }

  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}${endpoint}`,
    params,
  })
}

function getMeasureColorRangeApi(params) {
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}reports/measure/${params.payload.measure}/color-range`,
  })
}

export function* getStatusSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const statusApi = yield call(getStatusApi, params.payload)
    const result = statusApi.data.data

    /* revisar measure_engagement en caso de bug */
    if (statusApi.data.data.measure_climate) {
      params.payload.position = statusApi.data.data.measure_climate.id_position
      params.payload.isLeadership =
        statusApi.data.data.survey.id_survey_type === 2

      let userIsAmbassador = isAmbassador()

      params.payload.divisionToUseAmbassador = userIsAmbassador
        ? params.payload.params.id_division
        : ""

      const comparative_history = yield fork(hasComparativeHistoryCompany)
      const [evolution_history, divisionsAvailable] = yield all([
        call(getEvolutionHistoryMeasure, params.payload),
        call(getDivisionsAvailableApi, params.payload),
      ])

      result.divisions_available = divisionsAvailable.data.data
      result.measure_general = result.measure

      result.has_comparative = comparative_history
        ? comparative_history.data
        : ""
      result.evolution_measure = evolution_history ? evolution_history.data : ""

      if (result.user_type && result.survey.id_survey_type === 2) {
        result.user_type.divisions = []
      }

      // Excluir solo si tiene metricas aisladas
      if (!result.isolated_metrics) {
        setItem(KEY_CHECKBOX_EXCLUDE, false)
        setItem(KEY_ISOLATED_METRICS, false)
        params.payload.isExclude = false
      }

      if (result.measure_climate && result.measure_climate.percent) {
        params.payload.engagement = result.survey.engagement
        yield fork(getDimensionsSaga, params)
        if (result.survey.id_survey_type === 2 && params.payload.isHome) {
          // liderazgo
          yield fork(getTeamsSaga, params)
        }
        if (params.payload.isHome) {
          yield fork(getRanksSaga, params)
        }
        if (result.survey.engagement) {
          params.payload.dimensionType = "Engagement"
          params.payload.isEngagement = true
          yield fork(getDivisionsSaga, params)
        } else {
          yield fork(getDivisionsSaga, params)
        }
        if (result.measure) {
          params.payload.id_survey = result.measure.id_survey
          // El status no depende de lo cualitativo: si eso falla, el resto igual se muestra
          yield put(getStatusSuccess(result))
          try {
            const qualitative = yield call(getQualitativeApi, params.payload)
            yield put(getQualitativeSuccess(qualitative.data.data))
          } catch (qualitativeError) {
            yield put(getQualitativeFailed())
          }
        } else {
          yield put(getStatusSuccess(result))
        }
      } else {
        yield put(getStatusSuccess(result))
      }
    } else {
      result.emptyState = true
      yield put(getStatusSuccess(result))
    }
  } catch (error) {
    yield put(getStatusFailed())
    if (error.response && error.response.status === 404) {
      // params.payload.history.push('/reports')
      params.payload.history.push("/error")
    } else if (error.response && error.response.status === 401) {
      // ANCHOR: Redirect Login
      params.payload.history.push("/login")
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getDivisionsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token

    // Condition for remove id_division if it's not ambassador
    if (!validRole({ role: [5] })) {
      params.payload.params = {}
    }

    const [divionsApi, ambassadorsApi] = yield all([
      call(getDivisionsApi, params.payload),
      call(fetchGlobalApi, { method: "GET", endpoint: `ambassadors` }),
    ])
    let iteratorHere = divionsApi.data.data
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    if (validRole({ role: [1, 2, 3, 4] }) && isAmbassador) {
      iteratorHere = map(divionsApi.data.data, (item) => {
        return {
          ...item,
          ambassadors: filter(
            ambassadorsApi.data.data.result.ambassadors,
            (ambassador) => {
              return ambassador.divisions.some(
                (amb) => amb.id_division === item.id
              )
            }
          ),
        }
      })
    }

    const result = {
      divisions_general: divionsApi.data.data,
      divisions: divionsApi.data.data,
      divisions_drilldown:
        iteratorHere.length > 0
          ? generateTree("id", "id_parent", iteratorHere)
          : [],
    }

    if (params.payload.isEngagement) {
      if (params.payload.dimensionType == "Engagement") {
        result.metric = divionsApi.data.measure_engagement
      } else {
        result.metric = divionsApi.data.metric_total
      }
    } else {
      result.metric = divionsApi.data.metric_total
    }
    yield put(getDivisionsSuccess(result))
  } catch (e) {
    yield put(getDivisionsFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getTeamsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const [divionsApi] = yield all([call(getTeamsApi, params.payload)])
    const result = {}
    result.teams = divionsApi.data.data
    result.teams_drilldown =
      divionsApi.data.data.length > 0
        ? generateTree(
            "id_position",
            "id_position_parent",
            divionsApi.data.data
          )
        : []
    yield put(getTeamsSuccess(result))
  } catch (e) {
    yield put(getTeamsFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getDimensionsSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const [dimensionsApi, questionsApi] = yield all([
      call(getDimensionsApi, params.payload),
      call(getQuestionsApi, params.payload),
    ])
    let dimensions = dimensionsApi.data.data
    let questions = questionsApi.data.data
    if (questions.error != "No data") {
      questions.map((e) => {
        e.id = parseInt(
          e.id_dimension + Math.floor(Math.random() * 1000000 + 1)
        )
      })
    } else {
      questions = []
    }
    if (dimensions.error === "No data") {
      dimensions = []
    }
    const result = {}
    result.metric_total = dimensionsApi.data.metric_total
    result.dimensions = dimensions
    result.dimensions_drilldown = generateTree("id", "id_parent", [
      ...JSON.parse(JSON.stringify(dimensions)),
      ...JSON.parse(JSON.stringify(questions)),
    ])
    if (params.payload.engagement) {
      result.metric_total.name = "Resultado total"
      result.metric_total.first = true
      result.dimensions_drilldown.unshift(result.metric_total)
    }
    yield put(getDimensionsSuccess(result))
  } catch (e) {
    yield put(getDimensionsFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getRanksSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const ranks = yield call(getRanksApi, params.payload)
    yield put(getRanksSuccess(ranks.data.data))
  } catch (e) {
    yield put(getRanksFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getMultipleSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    const { data: measureInfo } = yield call(
      getReportMeasureInfoApi,
      params.payload
    )
    params.payload.token = cancelSource.token
    const response = yield call(getMultipleApi, params.payload)
    yield put(getMeasureInfoSuccess(measureInfo))
    yield put(getMultipleSuccess(response.data.data))
  } catch (e) {
    yield put(getMultipleFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getMeasureColorRangeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getMeasureColorRangeApi, params)

    yield put(getMeasureColorRangeSuccess(response.data.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getQualitativeSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const { data: measureInfo } = yield call(
      getReportMeasureInfoApi,
      params.payload
    )

    if (measureInfo.data.id_survey_type === 2 && params.payload.isHome) {
      // liderazgo
      yield fork(getTeamsSaga, params)
    }

    params.payload.id_survey = measureInfo.data.id_survey || null

    // VLENG-11442: measureInfo solo resuelve id_survey (arriba) cuando la
    // request trae id_segment — ver ReportMeasureController@index (backend),
    // que deja measure->id_survey en null salvo que venga id_segment. En la
    // vista General de una medición segmentada (>1 segmento) el link "Ver
    // todas las respuestas" no fuerza id_segment a propósito (para no filtrar
    // answers/wordcloud a un solo segmento), así que id_survey llegaba null y
    // el selector de preguntas quedaba vacío. Fallback: todos los segmentos
    // de una medición comparten el mismo id_survey real (mismo patrón que
    // WidgetQualitativeBubbles/saga.js, VLENG-11404) — alcanza con el de
    // cualquiera para listar las preguntas. NO se toca params.payload.id_segment,
    // que sigue como llegó (null en este caso) para que answers/wordcloud
    // se mantengan agregados a todos los segmentos.
    if (
      !params.payload.id_survey &&
      Array.isArray(measureInfo.data.segments) &&
      measureInfo.data.segments.length > 0
    ) {
      const activeSegment = params.payload.id_segment
        ? measureInfo.data.segments.find(
            (segment) => segment.id_segment === params.payload.id_segment
          )
        : measureInfo.data.segments[0]
      params.payload.id_survey = (activeSegment && activeSegment.id_survey) || null
    }

    params.payload.measure_type = measureInfo.data.id_measure_type || null
    params.payload.id_survey_type = measureInfo.data.id_survey_type || null

    let userIsAmbassador = isAmbassador()
    params.payload.divisionToUseAmbassador = userIsAmbassador
      ? params.payload.params.id_division
      : ""

    const { data: divisionsAvailable } = yield call(
      getDivisionsAvailableApi,
      params.payload
    )
    const response = {}
    response.divisions_available = divisionsAvailable.data

    // getQualitativeApi devuelve null cuando no hay id_survey resuelto (caso
    // borde: medición sin segmentos configurados en absoluto) — eso solo
    // significa que no hay listado de preguntas cualitativas para mostrar, NO
    // que haya que saltear answers/wordcloud/sentiment-wordcloud: esos pegan a
    // reports/measure/{measure}/... y no dependen de id_survey. Para mediciones
    // segmentadas, el fallback de arriba (VLENG-11442) ya resuelve id_survey.
    const qualitativeResponse = yield call(getQualitativeApi, params.payload)
    const resultQualitative = qualitativeResponse
      ? qualitativeResponse.data.data.filter((item) => item.enabled)
      : []

    // El wordcloud plano y el sentiment-wordcloud son opt-in/opt-out
    // independientes vía flags: containers/Reports/QualitativeQuestion (vista
    // vieja) no pasa ninguno, así que sigue pidiendo solo el wordcloud plano
    // (comportamiento sin cambios). containers/Reports/SentimentAnalysis pasa
    // skipWordcloud + fetchSentimentWordcloud.
    const fetchSentiment = !!params.payload.fetchSentimentWordcloud
    const skipWordcloud = !!params.payload.skipWordcloud

    // La vista vieja (QualitativeQuestion) arma un wordcloud plano por
    // pregunta, así que necesita una pregunta concreta preseleccionada.
    // SentimentAnalysis en cambio default-selecciona "Todas las preguntas"
    // (FS-03 del PRD, ver SentimentAnalysis/index.js) — forzar acá la primera
    // pregunta desalineaba la data inicial (bubble chart + respuestas
    // filtradas por 1 sola pregunta) con lo que el selector mostraba.
    params.payload.question = fetchSentiment
      ? null
      : (resultQualitative[0] && resultQualitative[0].id_question) || null

    const effects = {
      answersApi: fetchSentiment
        ? call(getSentimentAnalysisAnswersApi, params.payload)
        : call(getQualitativeAnswersApi, params.payload),
    }
    if (!skipWordcloud) {
      effects.wordCloud = call(getWordCloudApi, params.payload)
    }
    if (fetchSentiment) {
      effects.sentimentWordcloud = call(getSentimentWordcloudApi, params.payload)
    }

    const { answersApi, wordCloud, sentimentWordcloud } = yield all(effects)

    let resultAnswers = answersApi.data

    yield put(getMeasureInfoSuccess(measureInfo))
    yield put(getQualitativeSuccess(resultQualitative))
    yield put(getQualitativeAnswersSuccess(resultAnswers))
    if (wordCloud) {
      yield put(getQualitativeAnswersWordCloudSuccess(wordCloud.data.data))
    }
    if (sentimentWordcloud) {
      yield put(
        getQualitativeAnswersSentimentWordcloudSuccess(sentimentWordcloud.data)
      )
    }
    yield put(getStatusSuccess(response))
  } catch (error) {
    yield put(getQualitativeFailed())
    yield put(getStatusFailed())
    if (error.response && error.response.status === 404) {
      params.payload.history.push("/error")
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

// Refetch on-demand del bubble chart de sentimiento (ej. cuando el usuario
// cambia la pregunta o la división en containers/Reports/SentimentAnalysis),
// sin repetir todo el bootstrap de getQualitativeSaga (measure info,
// divisiones, respuestas, etc).
export function* refetchSentimentWordcloudSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.payload.token = cancelSource.token
    const response = yield call(getSentimentWordcloudApi, params.payload)
    yield put(getQualitativeAnswersSentimentWordcloudSuccess(response.data))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}

export function* getMultipleChoiceQuestionSaga(params) {
  const cancelSource = axios.CancelToken.source()
  try {
    const result = {}

    yield fork(getDivisionsSaga, params)

    let userIsAmbassador = isAmbassador()
    params.payload.divisionToUseAmbassador = userIsAmbassador
      ? params.payload.params.id_division
      : ""

    const { data: divisionsAvailable } = yield call(
      getDivisionsAvailableApi,
      params.payload
    )

    result.divisions_available = divisionsAvailable.data

    if (params.payload.id_survey_type === 2 && params.payload.isHome) {
      // liderazgo
      yield fork(getTeamsSaga, params)
    }

    yield put(getStatusSuccess(result))
  } catch (error) {
    yield put(getStatusFailed())
    if (error.response && error.response.status === 404) {
      params.payload.history.push("/error")
    }
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
    }
  }
}
export function getQualitativeQuestionsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/employees`,
  })
}
export function getTemplateQualitativeQuestionsApi(params) {
  let url = `reports/measure/${params.measure}/answers/wordcloud/download`
  const isLeadershipMedition = params.measure_type === 2
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      "filter[type]": params.type,
      ...params.params,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function getTemplateQualitativeQuestionsApiProgress(params) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }reports/measure/${params.measure}/answers/wordcloud/download/progress`,
  })
}
function messageProgress(messagex) {
  message.loading(messagex, 0)
}
function messageSuccess(messagex) {
  message.success(messagex, 5)
}
function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}
function downloadTemplateQualitativeQuestions(url) {
  location.replace(url)
}
export function* getQualitativeQuestionsSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getTemplateQualitativeQuestionsApi, action.payload)
    let data

    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(getTemplateQualitativeQuestionsApiProgress, action.payload)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo descargado")
    yield call(downloadTemplateQualitativeQuestions, data.data[0].url)
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar archivo")
  }
}

// Descarga del Excel de sentiment-wordcloud (botón "Descargar" en
// containers/Reports/SentimentAnalysis) — mismo patrón de dispatch+polling
// que getQualitativeQuestionsSaga (wordcloud plano), pero apuntando a los
// endpoints propios de sentiment-wordcloud y sin filter[type] (la vieja
// convención que nunca se llega a poblar).
function getSentimentWordcloudDownloadApi(params) {
  let url = `reports/measure/${params.measure}/answers/sentiment-wordcloud/download`
  const isLeadershipMedition = params.id_survey_type === 2
  const extraParams = { ...params.params }
  if (isLeadershipMedition) {
    delete extraParams.id_division
  }
  return axios.request({
    method: "POST",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      "filter[question]": params.question,
      "filter[leader]": isLeadershipMedition ? params.division : null,
      ...extraParams,
    },
    url: `${process.env.API_URL + url}`,
  })
}

function getSentimentWordcloudDownloadProgressApi(params) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }reports/measure/${params.measure}/answers/sentiment-wordcloud/download/progress`,
  })
}

export function* downloadSentimentWordcloudSaga(action) {
  try {
    yield call(messageProgress, "Descargando archivo")
    yield call(getSentimentWordcloudDownloadApi, action.payload)
    let data

    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(
        getSentimentWordcloudDownloadProgressApi,
        action.payload
      )

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo descargado")
    yield call(downloadTemplateQualitativeQuestions, data.data[0].url)
  } catch (e) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar archivo")
  }
}

// Individual exports for testing
export default function* reportHomeSaga() {
  yield takeLatest(GET_STATUS_WATCHER, getStatusSaga)
  yield takeLatest(GET_DIMENSIONS_WATCHER, getDimensionsSaga)
  yield takeLatest(GET_DIVISIONS_WATCHER, getDivisionsSaga)
  yield takeLatest(GET_TEAMS_WATCHER, getTeamsSaga)
  yield takeLatest(GET_RANKS_WATCHER, getRanksSaga)
  yield takeLatest(GET_MULTIPLE_WATCHER, getMultipleSaga)
  yield takeLatest(GET_MEASURE_COLOR_RANGE_WATCHER, getMeasureColorRangeSaga)
  yield takeLatest(GET_QUALITATIVE_WATCHER, getQualitativeSaga)
  yield takeLatest(GET_QUALITATIVE_QUESTIONS_WATCHER, getQualitativeQuestionsSaga)
  yield takeLatest(
    REFETCH_SENTIMENT_WORDCLOUD_WATCHER,
    refetchSentimentWordcloudSaga
  )
  yield takeLatest(
    DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER,
    downloadSentimentWordcloudSaga
  )
  yield takeLatest(
    GET_MULTIPLE_CHOICE_QUESTION_WATCHER,
    getMultipleChoiceQuestionSaga
  )
}
